import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from './icons/Icons';
import { useLanguage } from '../LanguageContext';
export const Testimonials = () => {
  const {
    language
  } = useLanguage();
  const testimonials = [{
    quote: language === 'es' ? 'Llegué con manchas que llevaban años en mi cara. Después de 3 sesiones con Fernanda, no puedo creer lo que veo en el espejo. Es un lugar diferente — te hacen sentir especial.' : "I arrived with spots that had been on my face for years. After 3 sessions with Fernanda, I can't believe what I see in the mirror. It's a different place — they make you feel special.",
    author: language === 'es' ? 'Cliente de Philadelphia' : 'Client from Philadelphia'
  }, {
    quote: language === 'es' ? 'El HydraFacial fue una experiencia increíble. Salí sintiéndome nueva. Fernanda es muy profesional y detallista. Ya soy cliente frecuente.' : 'The HydraFacial was an incredible experience. I left feeling new. Fernanda is very professional and detail-oriented. I am already a frequent client.',
    author: language === 'es' ? 'Cliente de Skin Glow Studio 22' : 'Skin Glow Studio 22 Client'
  }, {
    quote: language === 'es' ? 'Tenía mucho miedo de hacer el PRP pero Fernanda me explicó todo y me hizo sentir en confianza. Los resultados son reales. Mi piel rejuveneció notablemente.' : 'I was very afraid to do PRP but Fernanda explained everything to me and made me feel confident. The results are real. My skin rejuvenated noticeably.',
    author: language === 'es' ? 'Cliente frecuente' : 'Frequent client'
  }, {
    quote: language === 'es' ? 'La IV Therapy me cambió la vida. Entré cansada, sin energía. Salí sintiéndome completamente renovada. Ahora es parte de mi rutina mensual.' : 'IV Therapy changed my life. I went in tired, with no energy. I left feeling completely renewed. Now it is part of my monthly routine.',
    author: language === 'es' ? 'Cliente de Skin Glow Studio 22' : 'Skin Glow Studio 22 Client'
  }];
  return <section id="testimonios" className="py-12 md:py-16 bg-brand-cream relative overflow-hidden" data-id="element-400">
      <div className="container mx-auto px-6 max-w-6xl relative z-10" data-id="element-401">
        <div className="text-center mb-8 md:mb-10" data-id="element-402">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-4" data-id="element-403">
            {language === 'es' ? 'Testimonios' : 'Testimonials'}
          </h2>
          <p className="text-xl text-brand-bronze font-serif italic" data-id="element-404">
            {language === 'es' ? 'Historias reales. Resultados reales.' : 'Real stories. Real results.'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-405">
          {testimonials.map((testimonial, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1
        }} className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-brand-cream relative" data-id="element-406">
              <div className="absolute top-8 right-8 text-brand-gold/10" data-id="element-407">
                <QuoteIcon size={60} data-id="element-408" />
              </div>

              <div className="flex space-x-1 mb-6 relative z-10" data-id="element-409">
                {[...Array(5)].map((_, i) => <div key={i} className="text-brand-gold" data-id="element-410">
                    <StarIcon size={18} fill="currentColor" data-id="element-411" />
                  </div>)}
              </div>

              <p className="text-lg text-brand-charcoal/80 leading-relaxed mb-8 relative z-10 italic" data-id="element-412">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center space-x-4 relative z-10" data-id="element-413">
                <div className="h-px w-8 bg-brand-gold" data-id="element-414"></div>
                <p className="text-sm font-medium text-brand-charcoal uppercase tracking-wider" data-id="element-415">
                  {testimonial.author}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};